import { Component, OnInit, } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { PortalHotToastService, setupUntilDestroy } from '@portal-workspace/grow-ui-library';
import { GetCronJobInstancesFn, GetCronJobsFn, RunCronJobFn, GetCronJobsGroupedFn } from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { ApplicationService } from '../../service/application.service';
import { CronJobsComponent } from '@portal-workspace/grow-ui-library';
import { CronJobInstanceComponent } from '@portal-workspace/grow-ui-library';
import { Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthService } from '../../service/auth.service';
import { CronJobService } from '../../service/cron-job.service';

@UntilDestroy({ arrayName: 'subscriptions' })
@Component({
    templateUrl: './cron-management.page.html',
    styleUrls: ['./cron-management.page.scss'],
    standalone: true,
    imports: [MatCardModule, MatTabsModule, CronJobsComponent, CronJobInstanceComponent, MatTooltipModule, FlexModule, MatChipsModule, MatCheckboxModule, FormsModule, ReactiveFormsModule, MatDividerModule, MatFormFieldModule, MatInputModule, MatButtonModule]
})
export class CronManagementPage implements OnInit {
 
  getCronJobsFn!: GetCronJobsFn;
  getCronJobsGroupedFn!: GetCronJobsGroupedFn;
  getCronJobInstancesFn!: GetCronJobInstancesFn;
  runCronJobFn!: RunCronJobFn;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    private toastService: PortalHotToastService,
    private authService: AuthService,
    private cronJobService: CronJobService,
  ) {
    this.getCronJobsGroupedFn = this.cronJobService.getCronJobsGroupedFn;
    this.getCronJobInstancesFn = this.cronJobService.getCronJobInstancesFn;
    this.runCronJobFn = this.cronJobService.runCronJobFn;
  }


  ngOnInit(): void {
    setupUntilDestroy(this);
  }

   
}
